export default __webpack_public_path__ + "static/media/partner-16.661e5448.png";